import { useContext, useEffect } from 'react';
import { QuestionsContext } from '../../context/Questions';
import './progressbar.scss';

interface IProgressBar {
    progress: string | number;
}

function ProgressBar(props: IProgressBar) {
    const { progress } = props;
    const { progressQuestions, changeProgressQuestions } =
        useContext(QuestionsContext);

    useEffect(() => {
        changeProgressQuestions(progress);
    }, [progress]);

    return (
        <div className="Progress">
            <div className="ProgressBg">
                <div
                    className="ProgressBar"
                    style={{ width: '' + progressQuestions + '%' }}
                ></div>
            </div>
            <div className="ProgressNum">{'' + progressQuestions + '%'}</div>
        </div>
    );
}

export default ProgressBar;
